module.exports = __webpack_public_path__ + "static/media/plan_white.9f3249d6.svg";